<template>
  <!--  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
  <!--    <path d="M7.99998 0L7.37448 8L7.99998 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 7.99998 0Z" fill="white" />-->
  <!--    <path d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16V0Z" fill="white" />-->
  <!--    <path d="M9.60204 6.39745V3.46582H7.99998L7.37448 7.97426L7.99998 12.5332H9.60204V9.60157H12.5337V6.39745H9.60204Z" fill="currentColor" />-->
  <!--    <path d="M6.39793 3.46582V6.39745H3.46631V9.60157H6.39793V12.5332H8V3.46582H6.39793Z" fill="currentColor" />-->
  <!--  </svg>-->
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.60204 3.39745V0.46582H4.99998L4.37448 4.97426L4.99998 9.5332H6.60204V6.60157H9.53367V3.39745H6.60204Z" fill="currentColor" />
    <path d="M3.39793 0.46582V3.39745H0.466309V6.60157H3.39793V9.5332H5V0.46582H3.39793Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Pharmacy',
};
</script>
